module.exports = "/images/icon_medication_status.png?df5e366079ca73b98fa56d8642dc1fe9";